import api from 'Application/api/api';

const editManufacturer = (signal, values) =>
	api.put('/manufacturers', values, {
		signal,
	});

export default editManufacturer;
